import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from '../../../../styles/theme'

export const ButtonIcon = styled(ButtonPlain).attrs({
	tabIndex: -1,
})`
	background-color: ${helpers.color.input.buttonIconBackground};
	border-radius: 0;
	min-width: 36px;
	padding: 0 8px;
	color: ${helpers.color.input.buttonIcon};
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: auto;
	transition: background-color 135ms ease, color 135ms ease;

	&:disabled {
		color: ${helpers.color.input.buttonIconDisabled};
	}

	&:hover:enabled,
	&:focus:enabled {
		color: ${helpers.color.input.buttonIconHover};
		background-color: ${helpers.color.input.buttonIconBackgroundHover};
	}
`
